import { useNavigate } from "react-router-dom";
import urls from "../../config/urls.json";
import { useSession } from "../../hooks/useSession";
import { useAppointmentResponse } from "../../hooks/useAppointmentResponse";
import { useDynatrace } from "../../hooks/useDynatrace";

export const useDatiPersonaliRiconosciutoPage = () => {
  const navigate = useNavigate();
  const { read, update, batchUpdate } = useSession();
  const { handleAppointmentSubmission, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useAppointmentResponse();

  const edit = () => {
    // update("email", "");
    // update("cellulare", "");
    batchUpdate({
      email: "",
      cellulare: "",
    });
    navigate(urls.datiPersonaliNonRiconosciuto.path, { replace: true, state: { lockFields: true } });
  };

  const next = async () => {
    handleAppointmentSubmission();
  };

  const {} = useDynatrace();

  return {
    edit,
    next,
    read,
    isCreaAppuntamentoBusy,
    isCreaAppuntamentoError,
    fetchErrorMessage,
    fetchError,
    setFetchError,
  };
};
